import { IUser, ResourceAutoCompleteViewModelType } from '@ViewModels';
import { css, StyleDeclarationValue } from 'aphrodite';
import React, { useEffect, useState } from 'react';
import { getDisplayName } from '../../../../../models/NameUtils';
import { ViewModelTypeAutocomplete } from '../../../../containers/Settings/PhoneNumbers/components/ViewModelTypeAutocomplete';
import { styleSheet } from '../styles';

interface IProps {
	onChange: (user: IUser) => void;
	selectedManager?: IUser | null;
	className?: string;
	autoCompleteInputWrapperStyles?: StyleDeclarationValue[];
}

export const ManagerSelect: React.FC<IProps> = ({
	onChange,
	selectedManager,
	className,
	autoCompleteInputWrapperStyles,
}) => {
	const [selectedItem, selectItem] = useState<IUser>(selectedManager || null);

	// Reset internal state when selectedManager prop changes (including when cleared)
	useEffect(() => {
		selectItem(selectedManager || null);
	}, [selectedManager]);

	const handleSelection = (value: IUser) => {
		onChange(value);
		selectItem(value);
	};

	return (
		<ViewModelTypeAutocomplete<IUser>
			className={className || css(styleSheet.autocomplete)}
			defaultSelected={selectedItem}
			placeholder={selectedItem ? 'Manager: ' + getDisplayName(selectedItem) : 'Filter by Manager'}
			model={ResourceAutoCompleteViewModelType.Manager}
			onChange={handleSelection}
			autoCompleteInputWrapperStyles={autoCompleteInputWrapperStyles}
		/>
	);
};
